import React from 'react';
import { FISH_HEALTH, fishHealth } from "../../../util/varibles/constants";

interface IProps {
    value?: FISH_HEALTH | null

    onChange?(value: FISH_HEALTH | null): void
}

const SelectFishHealth: React.FC<IProps> = ({ value, onChange }) => {
    return <div className='flex items-center gap-2 flex-wrap'>
        {Object.keys(fishHealth).map(key => {
            const { id, name, color, bg } = fishHealth[key];
            const style = id === value ? { background: bg, color, cursor: 'default' } : { cursor: 'pointer' };
            return <div
                key={id}
                onClick={() => onChange?.(id)}
                style={{ ...style, transition: 'all .3s' }}
                className={"h-[32px] rounded-2xl px-[12px] flex items-center text-[15px]"}
            >
                {name}
            </div>
        })}
        <div className='link' onClick={() => onChange?.(null)}>
            Remove status
        </div>
    </div>;
};

export default SelectFishHealth;
